import ObjectsUpdater from "@/mixins/ObjectsUpdater";
// import Vue from "vue";

export default {
  name: "Login",

  mixins: [ObjectsUpdater],

  data: () => ({
    logo: { revapp: require("@/assets/logo.png") },
    email: "",
    password: "",
    rememberMe: true,
    namespaces: [],
    selectedNamespace: "",
    readOnlyNamespaceInput: false, // if user comes via mail and needs to authenticate to view content of specific namespace he should login to only this namespace
  }),

  methods: {
    // printVuetify() {
    //   console.log(this.$vuetify);
    // },
    getAllNamespaces() {
      if (
        this.email &&
        this.email.length &&
        (this.email == "admin" ||
          new RegExp(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ).test(this.email))
      ) {
        this.$http
          .get(this.$store.state.api + "/user/namespaces/" + encodeURIComponent(this.email))
          .then((response) => {
            if (response.data && response.data.length) {
              this.namespaces = response.data;
              if (!this.selectedNamespace.length) {
                this.selectedNamespace = this.namespaces[0];
              }
            }
          })
          .catch(() => {
            this.namespaces = [];
            this.selectedNamespace = "";
          });
      }
    },
    passwordReset() {
      this.$store.commit("setAuthDialog", {
        visible: true,
        user: { email: this.email },
        type: "passwordResetMail",
      });
    },
    login(totp) {
      let payload = {
        email: this.email,
        password: this.password,
      };

      if (totp) {
        payload.totp = totp;
      }

      if (this.selectedNamespace && this.selectedNamespace.length) {
        payload.namespace = this.selectedNamespace;
      }

      this.$http
        .post(this.$store.state.api + "/login", payload)
        .then((response) => {
          this.$store.commit("setJWT", response.headers.authorization);
          if (this.rememberMe) {
            localStorage.setItem("jwt", response.headers.authorization);
          }

          this.$http
            .get(this.$store.state.api + "/whoami", this.$store.getters.getAuthorizationHeader)
            .then((response) => {
              this.$store.state.showLoading = true;
              var user = response.data;
              if (user.activeNamespace && user.activeNamespace.length) {
                this.$store.commit("setUser", user);

                this.$updateObjects();

                if (
                  localStorage.getItem("requestUrl") != "null" &&
                  user.email === localStorage.getItem("requestor")
                ) {
                  this.$router.push(localStorage.getItem("requestUrl"));
                } else {
                  this.$router.push({ name: "Dashboard" });
                }
                localStorage.setItem("requestUrl", null);
                localStorage.setItem("requestor", null);
              } else {
                console.log(this.$t("views.login.noNamespaceFound"));
                this.$store.commit("setSnackbar", {
                  text: "Login failed",
                  color: "var(--attention)",
                });
              }
              setTimeout(() => {
                this.$store.state.showLoading = false;
              }, 1000);
            });
        })
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.message &&
            err.response.data.message.toLowerCase().indexOf("totp") > -1
          ) {
            this.$store.commit("setAuthDialog", {
              visible: true,
              type: "twoFactorAuth",
              user: payload,
              callback: (code) => {
                this.login(code);
              },
            });
          } else {
            this.$store.commit("setSnackbar", {
              text: "Login failed",
              color: "var(--attention)",
            });
          }
        });
    },
  },

  watch: {
    email(newValue, oldValue) {
      if (newValue.length - oldValue.length > 1) {
        this.getAllNamespaces();
      }
    },
  },

  mounted() {
    this.$store.state.jwt = null;
    localStorage.setItem("jwt", null);
    if (
      localStorage.getItem("targetNamespace") &&
      localStorage.getItem("targetNamespace") != "null"
    ) {
      this.selectedNamespace = localStorage.getItem("targetNamespace");
      localStorage.setItem("targetNamespace", null);
      this.readOnlyNamespaceInput = true;
    }

    if (localStorage.getItem("requestor") && localStorage.getItem("requestor") != "null") {
      this.email = localStorage.getItem("requestor");
    }
  },
};
